import React, { ReactNode, useMemo, useState } from 'react'

import { TopBarContext } from 'features/project/partials/project-layout/contexts/use-top-bar'

export const TopBarProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [topNavActions, setTopNavActions] = useState<ReactNode | null>(null)
  const [breadcrumbSubtitle, setBreadcrumbSubtitle] = useState<string | null>(
    null,
  )

  const value = useMemo(
    () => ({
      topNavActions,
      setTopNavActions,
      breadcrumbSubtitle,
      setBreadcrumbSubtitle,
    }),
    [topNavActions, breadcrumbSubtitle],
  )

  return (
    <TopBarContext.Provider value={value}>{children}</TopBarContext.Provider>
  )
}
